import { createContext, useContext, type JSX } from 'solid-js';
import toast, { Toaster } from 'solid-toast';
import { useNavigate } from '@solidjs/router';

type ToastProviderContext = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  apiPromise: (promise: Promise<any>, errorMessage: string, successMessage?: string) => Promise<any>;
};

// Create a context for the toast provider
const ToastContext = createContext<ToastProviderContext>();

// Custom hook to use the toast context
export function useToast() {
  return useContext(ToastContext);
}

type ToastProviderProps = {
  children?: JSX.Element;
};

export type ApiPromise = (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  promise: Promise<any>,
  errorMessage: string,
  successMessage?: string,
) => Promise<any>;

// ToastProvider component
export function ToastProvider(props: ToastProviderProps) {
  const navigate = useNavigate();

  // TODO: promise should always be fetch type
  const apiPromise = async (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    promise: Promise<any>,
    errorMessage: string,
    successMessage?: string,
  ) => {
    try {
      const res = await promise;

      if (res.status < 300) {
        if (successMessage) {
          toast.success(successMessage);
        }

        return res.json();
      }

      // TODO: handle none json response
      const { error } = await res.json();

      if (error && error === 'Invalid entity') {
        navigate('/entities');
        return;
      }

      if (res.status === 401) {
        navigate('/auth/login');
        toast.error(error || errorMessage);
        return;
      }

      toast.error(error || errorMessage, { duration: 5000 });
      throw error;
    } catch (error) {
      toast.error(errorMessage);
      throw error;
    }
  };

  return (
    <ToastContext.Provider
      value={{
        apiPromise,
      }}
    >
      <Toaster position="bottom-right" />
      {props.children}
    </ToastContext.Provider>
  );
}
